import { useEffect, useRef, useState } from 'react'
import { defaultLocale } from '@/constants/locales'
import { useExperimentContext } from '@/experimentation'
import { GuildAccessNotch } from '@/molecules/GuildAccessNotch'
import { Thumbnail } from '@/molecules/Thumbnail'
import { WatchHoverModal } from '@/organisms/WatchHoverModal'
import { useGuildMember } from '@/services/GuildUserService'
import { LinkViewProps } from '@/services/RenderService'
import { formatCloudinaryPath } from '@/utils/Cloudinary/cloudinary'
import { useLocale } from '@/utils/LocaleUtil'
import useWindowSize from '@/utils/useWindowSize'

export function LandscapeLink(props: LinkViewProps) {
  const [isHovered, setIsHovered] = useState(false)
  const [canShowHover, setCanShowHover] = useState(false)
  const cardRef = useRef<HTMLDivElement>(null)
  const { isGuildMember } = useGuildMember()
  const { innerWidth } = useWindowSize()
  const { locale } = useLocale()
  const { getFeatureValue } = useExperimentContext()

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  useEffect(() => {
    if (innerWidth > 1023 && locale === defaultLocale) {
      const canShowHoverModal = getFeatureValue('watch-hover-modal-desktop', false)
      if (canShowHoverModal) {
        setCanShowHover(true)
      }
    }
  }, [innerWidth, getFeatureValue, locale])

  return (
    <div
      className="relative my-2 overflow-hidden rounded-lg duration-[400ms] ease-in-out hover:z-10 md:hover:scale-[1.05]"
      ref={cardRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Thumbnail
        showTitle={false}
        className="mr-4"
        href={props.link.linkUrl}
        cloudinaryImagePath={formatCloudinaryPath(props.link.imageUrl) as string}
        title={props.link.alt}
        includePlayCircle={false}
      />
      <GuildAccessNotch isInEarlyAccess={props.link.isInEarlyAccess} isGuildMember={isGuildMember} />
      {canShowHover && (
        <WatchHoverModal guid={props.link?.id} isVisible={isHovered} projectSlug={props.link?.projectSlug} />
      )}
    </div>
  )
}
